import { render } from "./exam-show.vue?vue&type=template&id=278c7b0a&scoped=true"
import script from "./exam-show.vue?vue&type=script&lang=js"
export * from "./exam-show.vue?vue&type=script&lang=js"

import "./exam-show.vue?vue&type=style&index=0&id=278c7b0a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278c7b0a"]])

export default __exports__